$( document ).ready( function() {

    var MainNav = {
        $root: $( 'html' ),
        $elem: $( '.main-navigation' ),
        $toggle: $( '#js-nav-toggle' ),
        isOpen: false,
        isInit: false,
        breakpoint: 900
    };

    MainNav.init = function() {
        // always listen to resize event to allow for dynamic initialization
        $( window ).on( 'resize', this._onResize );
        if (window.innerWidth < this.breakpoint) {
            this.setup();
        }
    };

    MainNav.setup = function() {
        if (this.isInit) return;

        $( this.$toggle ).on( 'click', this._toggleOnClick );
        $( this.$elem ).on( 'click', this._onElemClick );
        $( document ).on( 'keydown', this._onEsc );

        this.isInit = true;
    };
    MainNav.teardown = function() {
        if (!this.isInit) return;

        if (this.isOpen) {
            this.close();
        }

        $( this.$toggle ).off( 'click', this._toggleOnClick );
        $( this.$elem ).off( 'click', this._onElemClick );
        $( document ).off( 'keydown', this._onEsc );

        this.isInit = false;
    };

    MainNav.toggle = function() {
        if ( this.isOpen ) {
            this.close();
        } else {
            this.open();
        }
    };
    MainNav.open = function() {
        this.$root.css('overflow', 'hidden');
        this.$elem.addClass( 'is-open' );
        this.$toggle.addClass( 'is-active' );
        this.isOpen = true;
    };
    MainNav.close = function() {
        this.isOpen = false;
        this.$root.css('overflow', '');
        this.$toggle.removeClass( 'is-active' );
        this.$elem.removeClass( 'is-open' );
    };

    MainNav._toggleOnClick = function(e) {
        MainNav.toggle();
    };
    MainNav._onElemClick = function(e) {
        if ( e.target === MainNav.$elem[0] ) {
            MainNav.close();
        }
    };
    MainNav._onEsc = function(e) {
        if ( MainNav.isOpen && ( e.key === 27 || e.which === 27 ) ) {
            MainNav.close();
        }
    };
    MainNav._onResize = function(e) {
        if ( window.innerWidth < MainNav.breakpoint ) {
            MainNav.setup();
        } else {
            MainNav.teardown();
        }
    };

    MainNav.init();
});